import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cashItemContract } from "@common/contracts/cash-item.contract";
import { CashItemBatchItem } from "@common/schemas/domains/cashItem/cashItem.schema";
import { useScope } from "@state/scopeContext.lib";
import { getBackendAPIClient } from "@lib/backendAPIClient";
import { SUPPRESS_ERROR_TOAST_HEADER } from "@lib/backendClient";
import { invalidateCashItemQueries } from "./cashItemQueries";

const cashItemsContractClient = getBackendAPIClient(cashItemContract);

export function useCreateCashItemsMutation() {
    const { workspaceId } = useScope();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (items: CashItemBatchItem[]) => {
            if (!workspaceId) {
                throw new Error("Workspace is required");
            }

            const response = await cashItemsContractClient.createCashItems({
                params: { workspaceId },
                body: { items },
                extraHeaders: { [SUPPRESS_ERROR_TOAST_HEADER]: "true" },
            });
            if (response.status === 200) {
                return response.body;
            }

            throw new Error("Failed to import checks and deposits");
        },
        onSuccess: async () => {
            await invalidateCashItemQueries({ queryClient, workspaceId });
        },
    });
}
